<template>
    <div id="app">

        <vs-row vs-type="flex" vs-justify="space-between" >
        <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="3">
            <vs-button @click="newEvent" color="primary" type="filled">+ Terapeuta</vs-button>
        </vs-col>
        </vs-row>

        <br/>

        <vs-popup title="Remover Terapeuta" :active.sync="popupDeleted">
            <p class="mb-3">Pretende remover a(o) terapeuta {{nameToDeleted}}?</p>
            <div class="float-right">
                <vs-button @click="goToDeleted()" class="mr-5" color="primary" type="filled">Remover</vs-button>
                <vs-button @click="popupDeleted=false" color="warning" type="border">Cancelar</vs-button>
            </div>
        </vs-popup>

        <vs-popup  :active.sync="showModal" :title="title" @close="closepop" fullscreen>
            <vs-row vs-justify="center">
                <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
           
                    <br/>
                    <div class="vx-row mb-2">                    
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                            <h5>Terapeuta</h5>
                        </vs-col>
                        <vs-col vs-offset="0" vs-type="inline" vs-justify="left" vs-align="center" vs-w="4">                        
                            <vue-simple-suggest
                                placeholder="Nome ou ID"
                                v-model="rowSelected.person_id"
                                :list="getListTherapists"
                                :max-suggestions="20"
                                :min-length="3"
                                :debounce="500"
                                :filter-by-query="false"
                                :prevent-submit="true"                        
                                mode="select"
                                :nullable-select="true"
                                ref="suggestComponent"
                                value-attribute="cod_pessoa"
                                display-attribute="nome"
                                @select="onSuggestSelect"
                                name="pessoa"                              
                            >
                            </vue-simple-suggest>
                        </vs-col>
                        <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                            <span class="text-danger text-sm" v-show="person_error == true">Campo Obrigatório</span>
                        </vs-col>                    
                    </div>

                    <br/>
                    <div class="vx-row mb-3">                    
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                            <h5>SPA</h5>
                        </vs-col>
                        <vs-col v-if="displayNew || typeof rowSelected.spas.label !== 'undefined'" vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
                            <v-select
                                color="#4DFF00"
                                class="selectWidth460"
                                v-model="rowSelected.spas" 
                                name="spa" 
                                ref="refSpa"
                                label="label"
                                :clearable="false" 
                                :options="displayNew ? spaList : spasTherapistCount"
                            >          
                            </v-select>                     
                        </vs-col>   
                        <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                            <span class="text-danger text-sm" v-show="errors.has('spa')">{{ errors.first('spa') }}</span>
                        </vs-col>                                         
                    </div>

                    <br/>
                    <div class="vx-row">
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        </vs-col>
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                            <feather-icon class="mr-1" icon="FilterIcon"></feather-icon>
                            <v-select
                                class="selectWidth360"
                                v-model="filter"
                                name="filter"
                                label="name"
                                :clearable="false"
                                :options="filterCategories"
                                placeholder="Categoria"
                            >
                            </v-select>
                        </vs-col>
                    </div>
                    <div class="vx-row">                
                        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >
                            <h5>Eventos</h5>
                        </vs-col>
                        <vs-col vs-type="inline" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                            <vs-list>
                            
                            <div class="list-header-with-btn">
                                <vs-list-header title="Disponíveis" color="primary"></vs-list-header>
                                
                                <vs-button 
                                    class="mb-2" 
                                    title="Mover tudo"
                                    @click="transferAllEvents"
                                    icon-pack="feather" 
                                    icon="icon-chevrons-right"
                                    type="flat">
                                </vs-button> 
                            </div>

                            <draggable :list="eventosSpa" group="people" class="p-2 cursor-move firstDraggable" animation="300" @add="changingList" @start="onDragStart" @end="onDragEnd">
                                <vs-list-item :class="{ drag_selected: selectedEvents.includes(listItem.event_id) }" v-for="(listItem, index) in eventosSpa" :title="listItem.name" :data_category="listItem.event_category_id" :data_event="listItem.event_id" @mouseup.native="selectItem($event,listItem.event_id)">
                                </vs-list-item>
                            </draggable>
                            </vs-list>  
                        </vs-col>
                        <vs-col vs-type="inline" vs-justify="center" vs-align="center" vs-lg="5" vs-sm="4" vs-xs="12">
                            <vs-list>
                            
                            <div class="list-header-with-btn">
                                <vs-list-header title="Seleccionados" color="primary"></vs-list-header>
                                
                                <vs-button 
                                    class="mb-2" 
                                    title="Mover tudo"
                                    @click="removeAllEvents"
                                    icon-pack="feather" 
                                    icon="icon-chevrons-left"
                                    type="flat">
                                </vs-button> 
                            </div>

                            <draggable :list="rowSelected.eventos" group="people" class="p-2 cursor-move" animation="300" @add="changingList" @start="onDragStart" @end="onDragEnd">
                                <vs-list-item :class="{ drag_selected: selectedEvents.includes(listItem.event_id) }" v-for="(listItem, index) in rowSelected.eventos" :title="listItem.name" :data_category="listItem.event_category_id" :data_event="listItem.event_id" @mouseup.native="selectItem($event,listItem.event_id)">
                                </vs-list-item>
                            </draggable>
                            </vs-list>
                        </vs-col>                    
                    </div>
                                    
                    <div class="vx-row mb-2">   
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                            <span class="text-danger text-sm" v-show="errors.has('eventos')">{{ errors.first('eventos') }}</span>
                        </vs-col>  
                    </div>

                    <br/>
                    <div class="vx-row mb-6">
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                            <h5>Marcação</h5>
                        </vs-col>
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                            <vs-checkbox v-model="rowSelected.marcacao" vs-value="1" ></vs-checkbox>
                        </vs-col>
                    </div>             

                    <br/>
                    <div class="vx-row mb-6">
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                            <h5>Estado</h5>
                        </vs-col>
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                            <vs-radio v-model="rowSelected.status" vs-value="1" color="primary"
                                v-validate="'required'"
                                name="estado" 
                            >
                                Activo
                            </vs-radio>
                            &nbsp;&nbsp;&nbsp;
                            <vs-radio v-model="rowSelected.status" vs-value="0" color="danger"
                                    v-validate="'required'"
                                name="estado" 
                            >
                                Inactivo
                            </vs-radio>  
                        </vs-col>
                    </div>

                    <div class="vx-row mb-2">   
                        <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                            <span class="text-danger text-sm" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                        </vs-col>  
                    </div>
                    <br/>
                    <br/>
                    <vs-row vs-type="flex" vs-justify="center">                    
                        <vs-button v-if="displayNew" @click="addTerapeuta()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Novo</vs-button>
                        <vs-button v-if="displayEdit" @click="editTerapeuta()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Gravar</vs-button>
                                      
                    </vs-row>
                </vs-col>
            </vs-row>
        </vs-popup>

        <vs-table
            v-model="selectedTerapeuta"
            pagination
            max-items="10"
            search
            noDataText="Não foram encontrados registos"
            @selected="handleTerapeuta"
            :data="terapeutasSpa"
        >
            <template slot="header">
                <h3>
                Lista de Terapeutas
                </h3>
            </template>
            
            <template slot="thead">
                <vs-th>
                </vs-th>
                <vs-th>
                    Terapeuta
                </vs-th>
                <vs-th>
                    Marcações
                </vs-th>
                <vs-th>
                    Nº Spas Associados
                </vs-th>
                <vs-th>
                    Estado
                </vs-th>
                <vs-th style="width: 10px;">
                </vs-th>
            </template>
        
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="indextr % 2 == 0 ?'primary':indextr == 668?'danger':null">
                    <vs-td :data="data[indextr].name">
                    </vs-td>

                    <vs-td :data="data[indextr].nome">
                        {{data[indextr].nome}} 
                    </vs-td>

                    <vs-td v-if="data[indextr].schedule_authorization == 1" :data="data[indextr].schedule_authorization">
                        Sim
                    </vs-td>

                    <vs-td v-if="data[indextr].schedule_authorization == 0" :data="data[indextr].nome">
                        Não
                    </vs-td>

                    <vs-td :data="data[indextr].spa_count">
                        {{data[indextr].spa_count}}
                    </vs-td>

                    <vs-td v-if="data[indextr].status == 0" :data="data[indextr].status">
                        Inactivo
                    </vs-td>
                    <vs-td v-if="data[indextr].status == 1" :data="data[indextr].status">
                        Activo
                    </vs-td>
                    <vs-td style="padding: 0px;">
                        <vs-button icon="delete" @click="openDeletedPopup(data[indextr])" color="primary" type="flat"></vs-button>
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>

    </div>
</template>

<style scoped>
    .list-header-with-btn  { position: relative; }
    .list-header-with-btn button {
        position: absolute;
        top: 0;
        right: 0;
    }

    .drag_selected {
        background-color: rgb(var(--vs-primary));
        color: #FFFFFF;
    }
</style>

<script>
import themeConfig from '@/../themeConfig.js';

import draggable from 'vuedraggable'

import vSelect from 'vue-select';                                   

import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css';            

import axios from 'axios';   

import { Validator } from 'vee-validate';

const dict = {
  custom: {
    pessoa: {      
      required: 'Campo Obrigatório ',
    },
    spa: {
        required: 'Campo Obrigatório ',
    },
    cor: {
        required: 'Campo Obrigatório ',
    },
    estado: {
        required: 'Campo Obrigatório ',
    },
    eventos: {
        required: 'Selecione pelo menos um Evento dos disponíveis',
    },
    specialty: {
        required: 'Campo Obrigatório ',
    },
  }
};
Validator.localize('pt', dict);

export default{
    name: 'terapeuta',
    data: function() {
        return {
            displayNew :false,
            displayEdit : false,
            selectedEvents: [],
            showModal: false,
            title: '',
            selectedTerapeuta: {},
            terapeutasSpa: [],
            rowSelected: {
                person_id: '',
                eventos: [],
                marcacao: 0,
                spas: [],
            },
            eventosSpa: [],
            originalEventosSpa: [],
            spasTherapistCount: [],
            tempTotalSpaEvents: [],
            tempNewTotalSpaEvents: [],
            therapistSpecialty: [],
            spaList: [],
            person_error: false,
            count_p: 0,
            filter: {
                event_category_id: '0',
                name: 'Todas'
            },
            filterCategories: [],
            eventosSpaTemp: [],
            countChangingEventos: 0,
            toOpenModal: 0,
            lockToDeleted: 0,
            popupDeleted: false,
            nameToDeleted: '',
            idToDeleted: '',
        }
    },

    components: {
        'v-select': vSelect, 
        draggable,
        VueSimpleSuggest,
    },

    methods: {       
        handleTerapeuta(tr) {

            if(this.lockToDeleted){
                this.lockToDeleted = 0;
                return false;
            }

            this.title ='Editar Terapeuta';

            this.displayEdit = true;
            this.displayNew = false;

            this.rowSelected = JSON.parse(JSON.stringify(tr));

            if(this.rowSelected.schedule_authorization == '1'){
                this.rowSelected.marcacao = 1;
            }else{
                this.rowSelected.marcacao = 0;
            }

            if(this.rowSelected.eventos.length > 0){
                this.rowSelected.spa_id = this.rowSelected.eventos[0].spa_id;
            }

            this.getSpaCountByTherapist(this.rowSelected.therapist_id);
 
            if(this.rowSelected.eventos.length > 0){
                this.getSelectedEventsByTherapistAndSpa(this.rowSelected.therapist_id, this.rowSelected.spa_id);
            }else{
                this.rowSelected.spa_id = '';
                this.showModal = true;
            }

            this.rowSelected.temp_person_id = this.rowSelected.person_id;
            this.rowSelected.person_id = this.rowSelected.nome;
        },  

        editTerapeuta(){
            if(this.rowSelected.person_id == null || this.rowSelected.person_id == '' || this.$refs.suggestComponent.text == ''){
                this.person_error = true;
            }else{
                this.person_error = false;
            }

            this.$validator.validateAll().then(result => {
                if(this.person_error){
                    return false;
                }

                if (result){
                    if(this.tempTotalSpaEvents.length === 0){
                        this.notify('Por favor selecione evento(s) para o terapeuta', 'red');
                    }else{
                        let has_events = 0;
                        for (let i = 0; i < this.tempTotalSpaEvents.length; i++) {
                            if(this.tempTotalSpaEvents[i].events.length > 0){
                                has_events = 1;
                                break;
                            }
                        }
                        if(has_events == 0){
                            this.notify('Por favor selecione evento(s) para o terapeuta', 'red');
                            return false;
                        }

                        let that = this; 

                        if( typeof this.rowSelected.person_id === 'object') {   
                            this.rowSelected.temp_person_id = this.rowSelected.person_id.cod_pessoa;
                        }
                        this.rowSelected.tempTotalSpaEvents = this.tempTotalSpaEvents;

                        if(this.rowSelected.marcacao === null){
                            this.rowSelected.marcacao = '0';
                        }

                        this.$vs.loading();

                        axios({
                            method: 'put',
                            url: themeConfig.apiurl + '/spa/modify/therapist/' + this.rowSelected.therapist_id,
                            data: {
                                therapist: that.rowSelected,
                                temporary: false,
                                token: window.localStorage.getItem('usertoken'),
                            }
                        }).then(function (response) {           
                            if(response.status == 200){
                                that.getSpaTherapists();

                                that.notify('Registo modlificado com sucesso', 'green');
                            }        
                        }).catch(function (error){
                            console.log('Ocorreu um erro na gravação');
                            that.$vs.loading.close();
                        }).then(function(){
                            that.$refs.suggestComponent.text = '';
                        });
                    }
                }
            });
        },

        addTerapeuta() {
            if(this.rowSelected.person_id == null || this.rowSelected.person_id == '' || this.$refs.suggestComponent.text == ''){
                this.person_error = true;
            }else{
                this.person_error = false;
            }

            this.$validator.validateAll().then(result => {
                if(this.person_error){
                    return false;
                }

                if (result){
                    if(this.tempNewTotalSpaEvents.length === 0){
                        this.notify('Por favor selecione evento(s) para o terapeuta', 'red');
                    }else{
                        let  has_events = 0;
                        for (let  i = 0; i < this.tempNewTotalSpaEvents.length; i++) {
                            if(this.tempNewTotalSpaEvents[i].events.length > 0){
                                has_events = 1;
                                break;
                            }
                        }
                        if(has_events == 0){
                            this.notify('Por favor selecione evento(s) para o terapeuta', 'red');
                            return false;
                        }
                        
                        let that = this;

                        this.$vs.loading();

                        this.rowSelected.tempNewTotalSpaEvents = this.tempNewTotalSpaEvents;

                        axios({
                            method: 'post',
                            url: themeConfig.apiurl + '/spa/new/therapist',
                            data: {
                                terapeuta: this.rowSelected,
                                token: window.localStorage.getItem('usertoken'),
                            }
                        }).then(function (response) {           
                            if(response.status == 200){   

                                if(response.data === 'ERROR1'){
                                    that.notify('O terapeuta que pretende inserir já existe.', 'red');
                                    that.$vs.loading.close();
                                }else{

                                    that.getSpaTherapists();

                                    that.notify('Registo inserido com sucesso.', 'green')
                                }
                            }        
                        }).catch(function (error){
                            that.notify('Ocorreu um erro na gravação', 'red');
                            that.$vs.loading.close();
                        }).then(function(){
                            that.$refs.suggestComponent.text = '';
                        });
                    }                                   
                }
            }); 
        }, 

        // get lista de spas
        getSpaCountByTherapist(therapist_id){
            let that = this;
            this.$vs.loading();

            let  spas_ids = [];
            for (let  i = 0; i < that.spaList.length; i++) {
                spas_ids.push(that.spaList[i].spa_id);
            }

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/get/spa/count/byTherapist/' + therapist_id + '?token=' + window.localStorage.getItem('usertoken'),
                params: {
                    spas_ids: spas_ids,
                }
            }).then(function (response) {
                if(response.status == 200){
                    that.spasTherapistCount = response.data;
                    let  found = false;
                    for (let  i = 0; i < that.spasTherapistCount.length; i++) {
                        if(that.spasTherapistCount[i].spa_id == that.rowSelected.spa_id){
                            found = true;
                            that.rowSelected.spas.label = that.spasTherapistCount[i].label;
                            if(that.rowSelected.spas.spa_id == that.spasTherapistCount[i].spa_id){
                                that.getSpaEventosBySpaRooms(that.rowSelected.spas.spa_id, 'edit');
                            }else{
                                that.rowSelected.spas.spa_id = that.spasTherapistCount[i].spa_id;
                            }
                        }
                    }
                    if(!found){
                        that.rowSelected.spas.label = that.spasTherapistCount[0].label;
                        that.getSpaEventosBySpaRooms(that.spasTherapistCount[0].spa_id, 'edit');
                    }
                    that.getEventCategories();
                }
            }).catch(function (error){
                console.log('error 1');
                console.log(error.response);
            }).then(function (response) {
                that.$vs.loading.close();
            });
        },

        // vai buscar eventos selected no spa da terapeuta 
        getSelectedEventsByTherapistAndSpa(therapist_id, spa_id) {
            if(typeof therapist_id !== 'undefined' && typeof spa_id !== 'undefined'){
                this.$vs.loading();
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/get/selectedEvents/byTherapistAndSpa?therapist_id=' + therapist_id + '&spa_id=' + spa_id + '&token='+window.localStorage.getItem('usertoken'), 
                }).then(function (response) {
                    if(response.status == 200){
                        that.rowSelected.eventos = response.data.filter(el => el.status == 1);
                        that.eventosSpaTemp = JSON.parse(JSON.stringify(that.rowSelected.eventos));
                        that.getRemainingSpaEventos(that.rowSelected, spa_id);
                    }
                }).catch(function (error){
                    console.log('error 2');
                    console.log(error.response);
                    that.$vs.loading.close();
                });
            }
        },

        // vai buscar os eventos disponiveis que nao estao selecionados
        getRemainingSpaEventos(rowSelected, spa_id) {
            let that = this; 

            axios({
                method: 'post',
                url: themeConfig.apiurl + '/spa/remaining/events/low/detail',
                data: {
                    token: window.localStorage.getItem('usertoken'),
                    room: rowSelected.eventos,
                    spa_id: spa_id,
                }
            }).then(function (res) {
                if(res.status == 200){
                    that.eventosSpa = res.data.filter(el => el.status == 1);
                    // eventosSpaTemp -> este array fica com todos os eventos(disponiveis e selecionados)
                    for (let  i = 0; i < that.eventosSpa.length; i++) {
                        that.eventosSpaTemp.push(that.eventosSpa[i]);
                    }
                    that.showModal = true;
                    that.$vs.loading.close();
                }                                      
            }).catch( function (err) {
                console.log('error 3');
                console.log(err);
            });     
        },

        getSpaTherapists(){
            let that = this;  
            let session = JSON.parse(window.localStorage.getItem('userSession'));
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/therapists/list',
                params: {
                    token: window.localStorage.getItem('usertoken'),
                    exploration: false,
                    cod_pessoa: session.id,
                }
            })
            .then(function (res) {
                if(res.status == 200){ 
                    that.terapeutasSpa = res.data.map(linha => {
                        return {
                            ...linha,
                            eventos: (linha.eventos || []).filter(el => el.status == 1)
                        };
                    });
                    that.$store.dispatch('storeListTherapists', that.terapeutasSpa);
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
            .then(function (response) {
                that.showModal = false;
                that.$vs.loading.close();
            }); 
        },

        getSpaEventos(){   
            let that = this; 

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/events/low/detail?token='+window.localStorage.getItem('usertoken'),
            }).then(function (res){ 
                if(res.status == 200){
                    that.eventosSpa = res.data;
                    that.originalEventosSpa = res.data;
                }                                      
            }).catch( function (err) {
                console.log(err);
            }); 
        },

        getSpaEventosBySpaRooms(spa_id, mode) {
            this.$vs.loading();
            let that = this; 
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/events/low/detail/bySpaRooms?token='+window.localStorage.getItem('usertoken'),
                params: {
                    spa_id: spa_id,
                }
            }).then(function (res) { 
                if(res.status == 200){
                    that.eventosSpa = res.data.filter(el => el.status == 1);
                    that.originalEventosSpa = res.data.filter(el => el.status == 1);
                    that.showAndHideSelectedEvents(spa_id, that.eventosSpa, mode);
                }                                      
            }).catch( function (err) {
                console.log(err);
                that.$vs.loading.close();
            });
        },

        showAndHideSelectedEvents(spa_id, events, mode){

            let  contentVar = (mode == 'edit') ? this.tempTotalSpaEvents : this.tempNewTotalSpaEvents;

            let  tempEvents = [];
            for (let  i = 0; i < contentVar.length; i++) {
                if(contentVar[i].spa_id == spa_id){
                    for (let j = 0; j < contentVar[i].events.length; j++) {
                        for (let k = 0; k < events.length; k++) {
                            if(contentVar[i].events[j] == events[k].event_id){
                                tempEvents.push(events[k]);
                                events.splice(k, 1);
                            }
                        }
                    }
                }
            }
            this.eventosSpa = events;
            this.eventosSpaTemp = JSON.parse(JSON.stringify(events));
            for (let i = 0; i < tempEvents.length; i++) {
                this.eventosSpaTemp.push(tempEvents[i]);
            }

            this.rowSelected.eventos = tempEvents;

            this.$vs.loading.close();
        },

        getTherapistSpecialty(){
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/therapist/specialty?token='+window.localStorage.getItem('usertoken'),
            })
            .then(function (res) { 
                if(res.status == 200){   
                    that.therapistSpecialty = res.data;
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            });    
        },

        getListTherapists(inputValue){
            let that = this;

            this.$vs.loading();
           
            return new Promise((resolve, reject) => {

                let url = themeConfig.apiurl + '/spa/therapists?input=' + inputValue + '&token='+window.localStorage.getItem('usertoken');
                fetch(url).then(response => 
                {
                    if (!response.ok) 
                    {
                        reject()
                        that.$vs.loading.close();
                    }

                    response.json().then(json => 
                    {
                        resolve(json)               
                        that.$vs.loading.close();   

                    }).catch(e => 
                    {
                        reject(e)
                        that.$vs.loading.close();  
                    });
                }).catch(error => {
                    this.loading = false
                    reject(error)
                    that.$vs.loading.close();
                })
            }) ;
        },  

        onSuggestSelect(suggest)  
        {   
            if(suggest != null) 
            {
                this.selected = suggest;                  
            }
        }, 

        boldenSuggestion(scope) {         
            if (!scope) return scope;
            const { suggestion, query } = scope;
            let result = this.$refs.suggestComponent.displayProperty(suggestion);
            if (!query) return result;
            const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
            return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)','gi'), '$1<b>$2</b>$3');
        },  

        newEvent() {
            this.title ='Adicionar Terapeuta';

            this.rowSelected.eventos = [];
            this.originalEventosSpa = [];
            this.eventosSpa = [];
            this.eventosSpaTemp = [];

            this.getEventCategories();

            this.displayNew = true;
            this.displayEdit = false;

            this.showModal = true;

        },

        getEventCategories(){
            this.$vs.loading();
            let that = this;
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/category/list?token='+window.localStorage.getItem('usertoken'),
            })
            .then(function (res) {
                if(res.status == 200){
                    let list = res.data;

                    that.filterCategories = [
                        {
                            event_category_id: '0',
                            name: 'Todas'
                        }
                    ];
                    for (let i = 0; i < list.length; i++) {
                        that.filterCategories.push(list[i]);
                    }
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
            .then(function (response) {
                that.$vs.loading.close();
            }); 
        },

        closepop(){
            this.toOpenModal = 1;
            this.countChangingEventos = 0;
            if(this.$validator.errors.items.length > 0)
            {                   
                while(this.$validator.errors.items.length > 0)
                {
                    this.$validator.errors.items.pop();
                }
            }
            this.eventosSpa = [];
            this.eventosSpaTemp = [];
            this.originalEventosSpa = [];
            this.rowSelected.eventos = [];
            this.person_error = false;
            this.$refs.suggestComponent.text = '';
            this.resetFilter();
            this.showModal = false;
        },

        clearFields(){
            this.toOpenModal = 1;
            this.countChangingEventos = 0;
            this.rowSelected.specialty = {
                spa_therapist_specialty_id: null,
                tag: null
            };
            this.rowSelected = {
                eventos: [],
                marcacao: 0,
                spas: {},
            };
            this.resetFilter();
            this.tempNewTotalSpaEvents = [];
        },
        resetFilter(){
            this.filter = [
                {
                    event_category_id: '0',
                    name: 'Todas'
                }
            ];
        },
        getSpas(){
            let that = this;
            let session = JSON.parse(window.localStorage.getItem('userSession'));

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/spas/byTherapist/' + session.id + '?token=' + window.localStorage.getItem('usertoken'),
            }).then(function (res) { 
                if(res.status == 200){   
                    that.spaList = res.data.filter(spa => spa.exploration != 1).map(function(value) {
                        value.label = value.name + ' | ' + value.hvg_nome;
                        return value;
                    });
                }                                                      
            }).catch( function (err) {
                console.log(err);
            });
        },
        changingList: function (evt) {
            let str = evt.to.attributes[0].value;
            let firstDraggable = str.includes("firstDraggable");
            if(firstDraggable){
                this.filterDisponiveis(this.filter.event_category_id);
            }

        },
        transferAllEvents(){
            this.rowSelected.eventos = JSON.parse(JSON.stringify(this.eventosSpaTemp));
            this.eventosSpa = [];

            this.selectedEvents = [];
            this.draggedItems = [];
        },
        removeAllEvents(){
            this.eventosSpa = JSON.parse(JSON.stringify(this.eventosSpaTemp));
            this.rowSelected.eventos = [];

            this.selectedEvents = [];
            this.draggedItems = [];
        },
        selectItem(event, id) {
            if (event.button != 0) return;
            
            let index = this.selectedEvents.indexOf(id)

            if (index === -1) {
                this.selectedEvents.push(id)
            } else {
                this.selectedEvents.splice(index, 1)
            }
        },  

        onDragStart(evt) {
            let list = evt.from.__vue__.list
            let draggedItem = list[evt.oldIndex]

            if (this.selectedEvents.includes(draggedItem.event_id)) {
                this.draggedItems = list.filter(item =>
                this.selectedEvents.includes(item.event_id)
            )
            } else {
                this.draggedItems = [draggedItem]
                this.selectedEvents = [draggedItem.event_id]
            }
        },

        onDragEnd(evt) {
            if (!this.draggedItems.length) return;

            let fromList = evt.from.__vue__.list;
            let toList = evt.to.__vue__.list;

            let ids = this.selectedEvents;

            let removedItems = [];
            for (let i = fromList.length - 1; i >= 0; i--) {
                if (ids.includes(fromList[i].event_id)) {
                    removedItems.unshift(fromList[i]);
                    fromList.splice(i, 1);
                }
            }

            toList.splice(evt.newIndex, 0, ...removedItems);

            this.selectedEvents = [];
            this.draggedItems = [];
        },
        filterDisponiveis(new_val){
            // volta a colocar todos os eventos no array dos disponiveis
            this.eventosSpa = JSON.parse(JSON.stringify(this.eventosSpaTemp));

            for (let i = 0, k = 0; k < this.eventosSpaTemp.length; i++, k++) {
                let cut = 0;
                // retira dos disponiveis os eventos que estao nos selecionados
                for (let j = 0; j < this.rowSelected.eventos.length; j++) {
                    if(this.rowSelected.eventos[j].event_id == this.eventosSpa[i].event_id){
                        cut = 1;
                        this.eventosSpa.splice(i, 1);
                        break;
                    }
                }
                if(typeof new_val != 'undefined' && new_val != 0 && cut == 0){
                    // retira dos disponiveis os que nao sao iguais ao filtro
                    if(this.eventosSpa[i].event_category_id != new_val){
                        cut = 1;
                        this.eventosSpa.splice(i, 1);
                    }
                }
                if(cut == 1){
                    i--;
                }
            }

        },

        openDeletedPopup(therapist){
            this.lockToDeleted = 1;
            this.nameToDeleted = therapist.name;
            this.idToDeleted = therapist.therapist_id;
            this.popupDeleted = true;
        },

        goToDeleted(){
            this.$vs.loading();
            let that = this;
            axios({
                method: 'post',
                url: themeConfig.apiurl + '/spa/deleted',
                data: {
                    token: window.localStorage.getItem('usertoken'),
                    therapist_id: this.idToDeleted,
                }
            }).then(function (res) {
                that.popupDeleted = false;
                that.getSpaTherapists();
                that.notify('A(O) Terapeuta '+that.nameToDeleted+' foi removido da lista.', 'green');
            }).catch( function (err) {
                that.notify('Erro ao remover a(o) terapeuta.', 'red');
            }).then(function (res) {
                that.$vs.loading.close();
            });
            
        },
    },

    created() {
        this.$vs.loading();
        this.getSpaTherapists();

        this.getSpas();
    },  

    computed: {
        terapeutasvg() {
            return this.$store.state.terapeutasvg;     
        },
        spasvg() {
            return this.$store.state.spasvg;
        },
    },  

    watch: {
        showModal(new_val,old_val) {
            if(!new_val){
                this.count_p++;
                this.clearFields();
            }
        }, 
        'rowSelected.spas.spa_id': function(new_val, old_val){
            if(this.displayEdit && new_val !== old_val && new_val !== '' && typeof old_val !== 'undefined'){

                let found_id = false;
                for (let i = 0; i < this.tempTotalSpaEvents.length; i++) {
                    if(this.tempTotalSpaEvents[i].spa_id == new_val){
                        found_id = true;
                    }
                }
                    
                this.resetFilter();
                if(found_id){
                    this.getSpaEventosBySpaRooms(new_val, 'edit');
                }else{
                    this.getSelectedEventsByTherapistAndSpa(this.rowSelected.therapist_id, new_val);
                }
                
            }

            if(this.displayNew && new_val !== old_val){
                this.getSpaEventosBySpaRooms(new_val, 'new');
            }
        },
        'rowSelected.eventos': function (new_val, old_val){
            if(this.displayEdit === true){
                let temp = JSON.parse(JSON.stringify(this.rowSelected));
                if(temp.eventos[0] && typeof temp.eventos[0].spa_id !== 'undefined'){
                    let temp_temp = [];
                    let id_repetidos = [];
                       
                    for (let i = 0; i < temp.eventos.length; i++) {

                        if(!id_repetidos.includes( temp.eventos[i].spa_id )){
                            temp_temp.push({
                                spa_id : temp.eventos[i].spa_id,
                                events : []
                            });                        
                        }
                        id_repetidos.push(temp.eventos[i].spa_id);
                    }
                    for (let i = 0; i < temp_temp.length; i++) {
                        let spa = temp_temp[i].spa_id;

                        for (let j = 0; j < temp.eventos.length; j++) {
                            if(temp.eventos[j].spa_id == spa ){
                               temp_temp[i].events.push(temp.eventos[j].event_id);
                            }
                        }
                    }
                    this.tempTotalSpaEvents = temp_temp;

                }else{

                    if(this.countChangingEventos >= 1){
                        let tempSpaEvents = {};
                        tempSpaEvents.spa_id = temp.spas.spa_id;
                        tempSpaEvents.events = temp.eventos.map((item) => item.event_id)

                        let indexTemp = this.tempTotalSpaEvents.findIndex( item => item.spa_id == tempSpaEvents.spa_id);

                        if(indexTemp === -1){
                            this.tempTotalSpaEvents.push(tempSpaEvents);
                        }else{
                            Object.keys( this.tempTotalSpaEvents[indexTemp]).forEach(k => this.tempTotalSpaEvents[indexTemp][k] = tempSpaEvents[k]);
                        }
    
                    }
                    if(this.toOpenModal == 0){
                        this.countChangingEventos++;
                    }
                    this.toOpenModal = 0;
                      
                }
            }

            if(this.displayNew === true && typeof this.rowSelected.spas !== 'undefined'){
                let temp = JSON.parse(JSON.stringify(this.rowSelected));

                let current_spa = this.rowSelected.spas.spa_id;

                if(this.rowSelected.spas.spa_id === current_spa){
                    let tempNewSpaEvents = {};
                    tempNewSpaEvents.spa_id = temp.spas.spa_id;
                    tempNewSpaEvents.events = temp.eventos.map((item) => item.event_id);

                    let indexNewTemp = this.tempNewTotalSpaEvents.findIndex( item => item.spa_id == tempNewSpaEvents.spa_id);

                    if(indexNewTemp === -1 && tempNewSpaEvents.spa_id !== ''){
                        this.tempNewTotalSpaEvents.push(tempNewSpaEvents); 
                    }else{
                        Object.keys( this.tempNewTotalSpaEvents[indexNewTemp]).forEach(k => this.tempNewTotalSpaEvents[indexNewTemp][k] = tempNewSpaEvents[k]);
                    }
                }
                
            }
        },
        'filter.event_category_id': function (new_val, old_val){

            this.filterDisponiveis(new_val);
            
        }

    },

}

</script>
